/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ComponentPropsWithoutRef } from 'react';

export default function CloseImgIcon(props: ComponentPropsWithoutRef<'svg'>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
            <path
                fill="#141617"
                d="M.433 15.595c.271.27.623.405.948.405.325 0 .704-.135.948-.405l5.685-5.676 5.685 5.676c.27.27.623.405.947.405.325 0 .705-.135.948-.405a1.337 1.337 0 0 0 0-1.92L9.909 8l5.685-5.675a1.337 1.337 0 0 0 0-1.92 1.342 1.342 0 0 0-1.923 0L7.986 6.081 2.33.46a1.342 1.342 0 0 0-1.923 0 1.337 1.337 0 0 0 0 1.918l5.685 5.676-5.657 5.648a1.305 1.305 0 0 0 0 1.891z"
            />
        </svg>
    );
}
